import React from 'react'
import WidgetContext from './WidgetContext'
import contextConnector from 'helpers/contextConnectorV2'

export default contextConnector(WidgetContext)
